import { Injectable, Injector } from '@angular/core';
import { EndpointFactory } from '../endpoint-factory.service';
import { HttpClient } from '@angular/common/http';
import { ForceBaseUrl, ConfigurationService } from '../configuration/configuration.service';
import { Product } from 'src/app/models/product';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductEndpoint extends EndpointFactory {

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('product', force) + 'product';
    }


    getProducts(tenantId: string): Observable<Product[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${tenantId}`;

        return this.http.get<Product[]>(endpointUrl)
            .pipe<Product[]>(
                catchError(error => {
                    return this.handleError(error);
                }));
    }

}
